/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Remove_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "Removes them from the event entirely. Only possible before the first round." |
*
* @param {Players_Remove_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_remove_confirm_body = /** @type {((inputs?: Players_Remove_Confirm_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Remove_Confirm_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le retire complètement du tournoi. Possible seulement avant la première ronde.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lo quita del torneo por completo. Solo es posible antes de la primera ronda.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remove-o totalmente do torneio. Só é possível antes da primeira rodada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lo toglie del tutto dal torneo. Possibile solo prima del primo round.")
	return /** @type {LocalizedString} */ ("Removes them from the event entirely. Only possible before the first round.")
});